import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getBookingExpense = createAsyncThunk('appDriver/getBookingExpense', async (GetExpenseList) => {
     
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetTableSummaryBookingExpense', GetExpenseList, {mode:'cors'})
     
    return response.data
  })

  export const getBookingExpenseTypeDriverApp = createAsyncThunk('appDriver/getBookingExpenseTypeDriverApp', async (GetExpenseList) => {
    const response = await axios.post('https://api.zasway.com:8443/BookingExpenseType/GetExpenseTypeListDriverApp', GetExpenseList, {mode:'cors'})
    return response.data
  })
  export const getBookingdetails = createAsyncThunk('DriverJourney/getBookingdetails', async (params) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Booking/GetBookingDetails', params, {mode:'cors'})
  
    return response.data
  })
  export const addExpense = createAsyncThunk('appDriver/addExpense', async (GetExpenseList) => {
    
    const response = await axios.post('https://api.zasway.com:8443/Driver/AddDriverExpenseFromDriverApp', GetExpenseList, {mode:'cors'})
    
    return response.data
  })
  
export const DriverExpensesSlice = createSlice({
  name: 'DriverExpensesStore',
  initialState: {
    data: [],
    Loader: false

  },
  reducers: {},
  extraReducers: builder => {
    builder

      .addCase(getBookingExpense.fulfilled, (state, action) => {

        state.data = action.payload.data
      })
      .addCase(addExpense.pending, (state) => {
        state.Loader = true
      })
      .addCase(addExpense.fulfilled, (state) => {
        state.Loader = false
      })

  }
})
export default DriverExpensesSlice.reducer